var map = {
	"./404/404.png": 1116,
	"./404/bg_404.png": 253,
	"./crossword.png": 1117,
	"./default.png": 499,
	"./folder.png": 126,
	"./logo.png": 474,
	"./logo2.png": 1118,
	"./logo_short.png": 1119,
	"./payment-holder.png": 500,
	"./rintagi-square.png": 501
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1115;


//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/.*\.png$
// module id = 1115
// module chunks = 0